export default {
    description: {
        booked_by: 'Rezervisao',
        booked_to: 'za',
    },
    link_to_reservation: 'Link do rezervacije',
}
